import Accordion from '@carvana/ds-accordion';
import Button from '@carvana/ds-button';
import { useTestFunc } from '@carvana/test-attributes';

import { FAQData } from './FAQStructuredData';
import {
  FAQAccordionWrapper,
  FAQButtonWrapper,
  FAQHeader,
  FAQSectionWrapper,
  SubText,
  TextContainer
} from './FAQSection.styles';
import useAnalyticEvent from 'shared/hooks/useAnalyticEvent';

const FAQSection = () => {
  const getTestAttributes = useTestFunc();
  const { recordActionClicked } = useAnalyticEvent();

  const handleChange = (isExpanded: boolean, headerText: string) => {
    if (isExpanded) {
      recordActionClicked('Landing Page', 'FAQ', { question: headerText });
    }
  };

  return (
    <FAQSectionWrapper>
      <TextContainer>
        <FAQHeader>Frequently asked questions</FAQHeader>
        <SubText>
          Have questions about selling or trading your car? We’ve got you covered.
        </SubText>
        <FAQButtonWrapper href="/help/sell-or-trade">
          <Button size="md" variant="secondary" {...getTestAttributes('ViewAllFAQs')}>
            View All FAQs
          </Button>
        </FAQButtonWrapper>
      </TextContainer>
      <FAQAccordionWrapper>
        {FAQData.map(({ q, a }) => (
          <Accordion
            key={q}
            toggleStyle="plus-minus"
            headerText={q}
            onExpandedChange={isExpanded => handleChange(isExpanded, q)}
          >
            <>
              {a.map(item => (
                <p key={item.toString()}>{item}</p>
              ))}
            </>
          </Accordion>
        ))}
      </FAQAccordionWrapper>
    </FAQSectionWrapper>
  );
};

export default FAQSection;
